/// <reference path='../../../../typings/index.d.ts' />
/// <reference path='walkinManagerSettings.module.ts' />

module Meevo.Plugins.WalkinManagerSettings {
  class WalkinManagerSettingsController extends Meevo.Components.CommonClasses.CommonControllerBase {
    // statically inject constructor resources
    static $inject = [
      'meevo.AppSettings',
      'meevo.plugins.walkinManagerSettings.walkInDataServiceSettings',
      'meevo.components.modal.ModalService',
      'meevo.components.common.IdentityService',
      'meevo.components.logging.LoggingService',
      'meevo.components.common.SecurityService',
      "meevo.components.tracking.TrackingService",
      '$rootScope',
      '$scope',
      '$state',
      'meevo.ContextParams',
      'meevo.components.short-cuts.ShortCutsService',
      'meevo.components.busy.BusyService'
    ];

    constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
      protected dataService: Meevo.Plugins.WalkinManagerSettings.IDataServiceSettings,
      protected modalService: Meevo.Components.Modal.IModalService,
      protected identityService: Meevo.Components.Common.IIdentityService,
      protected loggingService: Meevo.Components.Logging.ILoggingService,
      protected securityService: Meevo.Components.Common.ISecurityService,
      protected trackingService: Meevo.Components.Tracking.ITrackingService,
      protected $rootScope: angular.IRootScopeService,
      protected $scope: angular.IScope,
      protected $state: any,
      protected contextParams: Meevo.IContextParams,
      protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

      protected busyService: Meevo.Components.Busy.IBusyService
    ) {

      super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

      this.createContext();
    }

    createContext(): void {
      let vm = this;
      vm.busyService.start();
      vm.securityService.checkSection(vm.meevoSecurityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS).then(() => {
        vm.busyService.stop();
        vm.context = new WalkinManagerSettingsContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService);
        super.createContext();
      });
    }
  }

  angular.module('meevo.plugins.walkinManagerSettings')
    .controller('meevo.plugins.walkinManagerSettings.WalkinManagerSettingsController', WalkinManagerSettingsController);
}